import styled from '@emotion/styled'
import ContentWrapper from '@vio/atlas/helpers/ContentWrapper'
import {SegmentedControl} from '@vio/atlas/SegmentedControl'
import {cssTheme} from '@vio/atlas/themes'

export const PageWrapper = styled('div')`
  background: white;
  min-height: 100vh;
`

export const Content = styled(ContentWrapper)`
  display: flex;
  flex-direction: column;
  max-width: 500px;
`

export const HeaderSelector = styled(SegmentedControl)`
  display: flex;
  justify-content: flex-start;
  margin-bottom: ${cssTheme.layout.spacing.s600};
  justify-content: center;
`
